import Fuse, { IFuseOptions } from 'fuse.js';
import { TConsumerItem } from '../../../types/data';

const FUSE_OPTIONS: IFuseOptions<TConsumerItem> = {
    keys: ['title', 'alias'],
    // 2 ошибки
    threshold: 0.4,
    includeMatches: true,
    minMatchCharLength: 1,
    ignoreLocation: true,
};

export const filterBySearch = (search: string, items?: TConsumerItem[], isFiltering = true): TConsumerItem[] => {
    if (!items) return [];
    if (!isFiltering) return items.map((item) => addMarkByRegex(item, search));

    const fuse = new Fuse(items, FUSE_OPTIONS);
    return fuse.search(search).map(({ item, matches }) => {
        const titleMatch = matches?.find((m) => m.key === 'title');
        return addMarkByIndices(item, titleMatch?.indices ?? []);
    });
};

const addMarkByRegex = (item: TConsumerItem, search: string): TConsumerItem => {
    const reg = new RegExp(`(${search})`, 'gi');
    const clearTitle = item.title;
    const title = item.title?.replace(reg, `<mark>$1</mark>`);
    return { ...item, title, clearTitle };
};

const addMarkByIndices = (item: TConsumerItem, indices: readonly [number, number][]): TConsumerItem => {
    const clearTitle = item.title;
    if (!clearTitle) return { ...item, clearTitle };
    const title = indices.length > 0 ? applyMarks(clearTitle, indices) : clearTitle;
    return { ...item, title, clearTitle };
};

const applyMarks = (text: string, indices: readonly [number, number][]): string => {
    let result = '';
    let lastIndex = 0;
    for (const [start, end] of indices) {
        result += text.slice(lastIndex, start);
        result += `<mark>${text.slice(start, end + 1)}</mark>`;
        lastIndex = end + 1;
    }
    return result + text.slice(lastIndex);
};
